import autobind from 'autobind-decorator';
import { observable, computed, action } from 'mobx';
import BaseballMatchRelativeRecordVsRecordModel from './vsRecord';
import BaseballMatchRelativeRecordRecentRecordModel from './recentRecord';

@autobind
class BaseballMatchRelativeRecordModel {
  home;
  away;

  @observable
  vsRecord = [];

  @observable
  recentHomeRecord = [];

  @observable
  recentAwayRecord = [];

  @observable
  selectedRecentRecordTab = 'home';

  constructor(data, home, away) {
    this.vsRecord = data.vsRecord.map(
      (item) => new BaseballMatchRelativeRecordVsRecordModel(item)
    );

    this.recentHomeRecord = data.recentHomeRecord.map(
      (item) => new BaseballMatchRelativeRecordRecentRecordModel(item)
    );

    this.recentAwayRecord = data.recentAwayRecord.map(
      (item) => new BaseballMatchRelativeRecordRecentRecordModel(item)
    );

    this.home = home;

    this.away = away;
  }

  /**********************************************************
   * computed
   **********************************************************/
  @computed
  get recentRecord() {
    const {
      selectedRecentRecordTab,
      recentHomeRecord,
      recentAwayRecord
    } = this;

    if (selectedRecentRecordTab === 'home') {
      return recentHomeRecord;
    } else {
      return recentAwayRecord;
    }
  }

  @computed
  get tabs() {
    const { vsRecord, home, away } = this;

    if (vsRecord.length > 0) {
      if (!!home && !!away) {
        return {
          home: `${home.name} (홈)`,
          away: `${away.name} (원정)`
        };
      } else {
        return {
          home: `${home.name} (홈)`,
          away: `${away.name} (원정)`
        };
      }
    } else {
      return {
        home: `${home.name} (홈)`,
        away: `${away.name} (원정)`
      };
    }
  }

  /**********************************************************
   * actions
   **********************************************************/
  @action
  onClickTab(tab) {
    this.selectedRecentRecordTab = tab;
  }
}

export default BaseballMatchRelativeRecordModel;
